import { signal } from '@preact/signals-react';

// UUID for SSE connections - isolated to avoid circular dependencies
export const uuidSignal = signal(Math.floor(Math.random() * 1000000) + 1);
